var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-date-picker',{attrs:{"value":_vm.selectedMonth,"type":"month","color":"primary","reactive":""},on:{"input":_vm.onInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }